/** Single source for Bunny CDN hostname (used by VideoPlayer and direct video links). Override with VITE_BUNNY_CDN_HOSTNAME. */
export const BUNNY_CDN_HOSTNAME =
  (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_BUNNY_CDN_HOSTNAME) ||
  'vz-8d089320-6eb.b-cdn.net';

export function getBunnyMp4Url(videoId: string): string {
  return `https://${BUNNY_CDN_HOSTNAME}/${videoId}/play_720p.mp4`;
}
